import { trackGTMEvent, trackEventOnMixpanel } from "lib/utils";
import type { TalkData } from "content-ui/talks/types";

type SubmitTalkRegistrationParams = {
  talk: TalkData;
  marketingConsent: boolean | null;
  optionalConsent: boolean | null;
  userId: string | null;
};

const submitTalkRegistration = ({
  talk,
  marketingConsent,
  optionalConsent,
  userId,
}: SubmitTalkRegistrationParams): void => {
  trackGTMEvent({
    event: "talkRsvp",
    talkId: talk.id,
    talkName: talk.title,
    marketingConsent,
    optionalConsent,
    userId,
  });

  trackEventOnMixpanel({
    eventName: "talkRsvp",
    fields: {
      marketingConsent,
      optionalConsent,
      title: talk.title,
      talkId: talk.id,
      talkSector: talk.marketLabel,
      talkAction: "talkRsvp",
      path: window.location.pathname,
    },
  });
};

type SubmitTalkJoinParams = {
  talk: TalkData;
  userId: string | null;
};

const submitTalkJoin = async ({ talk, userId }: SubmitTalkJoinParams) => {
  trackGTMEvent({
    event: "talkCheckIn",
    talkId: talk.id,
    talkName: talk.title,
    userId,
  });

  trackEventOnMixpanel({
    eventName: "talkCheckIn",
    fields: {
      title: talk.title,
      talkId: talk.id,
      talkSector: talk.marketLabel,
      talkAction: "talkCheckIn",
      path: window.location.pathname,
    },
  });
};

export { submitTalkRegistration, submitTalkJoin };
